import { render } from "./CourseEditor.vue?vue&type=template&id=7d190fa4&scoped=true&ts=true"
import script from "./CourseEditor.vue?vue&type=script&lang=ts"
export * from "./CourseEditor.vue?vue&type=script&lang=ts"

import "./CourseEditor.vue?vue&type=style&index=0&id=7d190fa4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d190fa4"]])

export default __exports__